import TravelerTicketsContainer from './tickets-container';

export default TravelerTicketsContainer;
